'use client';

import * as React from 'react';
import { useFormContext } from 'react-hook-form';
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Checkbox } from '@/components/ui/checkbox';

interface FormCheckboxProps {
  name: string;
  label: string;
  checkboxText?: string | React.ReactNode;
  hint?: string | React.ReactNode;
  disabled?: boolean;
}

export function FormCheckbox({ name, label, checkboxText, hint, disabled }: FormCheckboxProps) {
  const form = useFormContext();

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <div className="flex flex-row items-start space-x-3 space-y-0">
            <FormControl>
              <Checkbox
                checked={field.value}
                onCheckedChange={field.onChange}
                disabled={disabled}
              />
            </FormControl>
            {checkboxText && (
              <div className="space-y-1 leading-none">
                <FormLabel className="cursor-pointer font-normal">{checkboxText}</FormLabel>
              </div>
            )}
          </div>
          {hint && <FormDescription>{hint}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
